const CSSSourceInfo = {
  cssColors: {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    goldenrod: '#daa520',
    gold: '#ffd700',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavenderblush: '#fff0f5',
    lavender: '#e6e6fa',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32',
  },
  cssKeyValue: {
    'align-content': {
      values: [
        'center',
        'flex-end',
        'flex-start',
        'space-around',
        'space-between',
        'stretch',
      ],
    },
    'align-items': {
      values: ['baseline', 'center', 'flex-end', 'flex-start', 'stretch'],
    },
    'align-self': {
      values: [
        'auto',
        'normal',
        'self-start',
        'self-end',
        'baseline',
        'center',
        'start',
        'end',
        'flex-end',
        'flex-start',
        'safe',
        'stretch',
        'unsafe',
      ],
    },
    all: { values: [] },
    animation: { values: [] },
    'animation-delay': { values: [] },
    'animation-direction': {
      values: ['alternate', 'alternate-reverse', 'normal', 'reverse'],
    },
    'animation-duration': { values: [] },
    'animation-fill-mode': {
      values: ['backwards', 'both', 'forwards', 'none'],
    },
    'animation-iteration-count': { values: ['infinite'] },
    'animation-name': { values: ['none'] },
    'animation-play-state': { values: ['paused', 'running'] },
    'animation-timing-function': {
      values: [
        'cubic-bezier()',
        'ease',
        'ease-in',
        'ease-in-out',
        'ease-out',
        'linear',
        'step-end',
        'step-start',
        'steps()',
      ],
    },
    'backface-visibility': { values: ['hidden', 'visible'] },
    background: { values: [], type: 'color' },
    'background-attachment': { values: ['fixed', 'local', 'scroll'] },
    'background-blend-mode': {
      values: [
        'color',
        'color-burn',
        'color-dodge',
        'darken',
        'difference',
        'exclusion',
        'hard-light',
        'hue',
        'lighten',
        'luminosity',
        'multiply',
        'normal',
        'overlay',
        'saturation',
        'screen',
        'soft-light',
      ],
    },
    'background-clip': { values: ['border-box', 'content-box', 'padding-box'] },
    'background-color': { values: [], type: 'color' },
    'background-image': {
      values: [
        'image()',
        'linear-gradient()',
        'radial-gradient()',
        'repeating-linear-gradient()',
        'repeating-radial-gradient()',
        'url()',
      ],
    },
    'background-origin': {
      values: ['border-box', 'content-box', 'padding-box'],
    },
    'background-position': {
      values: ['left', 'center', 'right', 'bottom', 'top'],
    },
    'background-repeat': {
      values: ['no-repeat', 'repeat', 'repeat-x', 'repeat-y', 'round', 'space'],
    },
    'background-size': { values: ['auto', 'contain', 'cover'] },
    border: { values: [] },
    'border-collapse': { values: ['collapse', 'separate'] },
    'border-color': { values: [], type: 'color' },
    'border-spacing': { values: [] },
    'border-style': {
      values: [
        'dashed',
        'dotted',
        'double',
        'groove',
        'hidden',
        'inset',
        'none',
        'outset',
        'ridge',
        'solid',
      ],
    },
    'border-bottom': { values: [] },
    'border-bottom-color': { values: [], type: 'color' },
    'border-bottom-left-radius': { values: [] },
    'border-bottom-right-radius': { values: [] },
    'border-bottom-style': {
      values: [
        'dashed',
        'dotted',
        'double',
        'groove',
        'hidden',
        'inset',
        'none',
        'outset',
        'ridge',
        'solid',
      ],
    },
    'border-bottom-width': { values: ['medium', 'thin', 'thick'] },
    'border-image': { values: ['url()'] },
    'border-image-outset': { values: [] },
    'border-image-slice': { values: [] },
    'border-image-source': { values: [] },
    'border-image-repeat': { values: ['repeat', 'round', 'space', 'stretch'] },
    'border-image-width': { values: ['auto'] },
    'border-left': { values: [] },
    'border-left-color': { values: [], type: 'color' },
    'border-left-style': {
      values: [
        'dashed',
        'dotted',
        'double',
        'groove',
        'hidden',
        'inset',
        'none',
        'outset',
        'ridge',
        'solid',
      ],
    },
    'border-left-width': { values: ['medium', 'thin', 'thick'] },
    'border-radius': { values: [] },
    'border-right': { values: [] },
    'border-right-color': { values: [], type: 'color' },
    'border-right-style': {
      values: [
        'dashed',
        'dotted',
        'double',
        'groove',
        'hidden',
        'inset',
        'none',
        'outset',
        'ridge',
        'solid',
      ],
    },
    'border-right-width': { values: ['medium', 'thin', 'thick'] },
    'border-top': { values: [] },
    'border-top-color': { values: [], type: 'color' },
    'border-top-left-radius': { values: [] },
    'border-top-right-radius': { values: [] },
    'border-top-style': {
      values: [
        'dashed',
        'dotted',
        'double',
        'groove',
        'hidden',
        'inset',
        'none',
        'outset',
        'ridge',
        'solid',
      ],
    },
    'border-top-width': { values: ['medium', 'thin', 'thick'] },
    'border-width': { values: ['medium', 'thin', 'thick'] },
    'box-decoration-break': { values: ['clone', 'slice'] },
    'box-shadow': { values: ['none'] },
    'box-sizing': { values: ['border-box', 'content-box'] },
    bottom: { values: ['auto'] },
    'break-after': {
      values: [
        'always',
        'auto',
        'avoid',
        'avoid-column',
        'avoid-page',
        'avoid-region',
        'column',
        'left',
        'page',
        'region',
        'right',
      ],
    },
    'break-before': {
      values: [
        'always',
        'auto',
        'avoid',
        'avoid-column',
        'avoid-page',
        'avoid-region',
        'column',
        'left',
        'page',
        'region',
        'right',
      ],
    },
    'break-inside': {
      values: ['auto', 'avoid', 'avoid-column', 'avoid-page', 'avoid-region'],
    },
    'caption-side': { values: ['bottom', 'top'] },
    'caret-color': { values: ['auto'], type: 'color' },
    clear: { values: ['both', 'left', 'none', 'right'] },
    clip: { values: ['auto'] },
    color: { values: [], type: 'color' },
    columns: { values: [] },
    'column-count': { values: [] },
    'column-fill': { values: ['auto', 'balance'] },
    'column-gap': { values: ['normal'] },
    'column-rule': { values: [] },
    'column-rule-color': { values: [], type: 'color' },
    'column-rule-style': {
      values: [
        'dashed',
        'dotted',
        'double',
        'groove',
        'hidden',
        'inset',
        'none',
        'outset',
        'ridge',
        'solid',
      ],
    },
    'column-rule-width': { values: ['medium', 'thin', 'thick'] },
    'column-span': { values: ['all', 'none'] },
    'column-width': { values: ['auto'] },
    content: {
      values: [
        'attr()',
        'close-quote',
        'no-close-quote',
        'no-open-quote',
        'normal',
        'none',
        'open-quote',
      ],
    },
    'counter-increment': { values: ['none'] },
    'counter-reset': { values: ['none'] },
    cursor: {
      values: [
        'alias',
        'all-scroll',
        'auto',
        'cell',
        'col-resize',
        'context-menu',
        'copy',
        'crosshair',
        'default',
        'e-resize',
        'ew-resize',
        'grab',
        'grabbing',
        'help',
        'move',
        'n-resize',
        'ne-resize',
        'nesw-resize',
        'no-drop',
        'none',
        'not-allowed',
        'ns-resize',
        'nw-resize',
        'nwse-resize',
        'pointer',
        'progress',
        'row-resize',
        's-resize',
        'se-resize',
        'sw-resize',
        'text',
        'vertical-text',
        'w-resize',
        'wait',
        'zoom-in',
        'zoom-out',
      ],
    },
    direction: { values: ['ltr', 'rtl'] },
    display: {
      values: [
        'block',
        'contents',
        'flex',
        'flow-root',
        'grid',
        'inline',
        'inline-block',
        'inline-flex',
        'inline-grid',
        'inline-table',
        'list-item',
        'none',
        'run-in',
        'subgrid',
        'table',
        'table-caption',
        'table-cell',
        'table-column',
        'table-column-group',
        'table-footer-group',
        'table-header-group',
        'table-row',
        'table-row-group',
      ],
    },
    'empty-cells': { values: ['hide', 'show'] },
    fill: { values: [] },
    filter: {
      values: [
        'blur()',
        'brightness()',
        'contrast()',
        'custom()',
        'drop-shadow()',
        'grayscale()',
        'hue-rotate()',
        'invert()',
        'none',
        'opacity()',
        'sepia()',
        'saturate()',
        'url()',
      ],
    },
    flex: { values: ['auto', 'none'] },
    'flex-basis': { values: ['auto'] },
    'flex-direction': {
      values: ['column', 'column-reverse', 'row', 'row-reverse'],
    },
    'flex-flow': {
      values: [
        'column',
        'column-reverse',
        'nowrap',
        'row',
        'row-reverse',
        'wrap',
        'wrap-reverse',
      ],
    },
    'flex-grow': { values: [] },
    'flex-shrink': { values: [] },
    'flex-wrap': { values: ['nowrap', 'wrap', 'wrap-reverse'] },
    float: { values: ['left', 'right', 'none', 'inline-start', 'inline-end'] },
    'flow-into': { values: ['none'], type: 'named-flow' },
    'flow-from': { values: ['none'], type: 'named-flow' },
    font: { values: [] },
    'font-display': {
      values: ['auto', 'block', 'swap', 'fallback', 'optional'],
    },
    'font-family': {
      values: [
        'auto',
        'cursive',
        'fantasy',
        'monospace',
        'sans-serif',
        'serif',
      ],
    },
    'font-feature-settings': { values: ['normal'] },
    'font-kerning': { values: ['auto', 'none', 'normal'] },
    'font-language-override': { values: ['normal'] },
    'font-size': {
      values: [
        'xx-small',
        'x-small',
        'small',
        'medium',
        'large',
        'x-large',
        'xx-large',
        'xxx-large',
        'larger',
        'smaller',
      ],
    },
    'font-size-adjust': { values: ['auto', 'none'] },
    'font-stretch': {
      values: [
        'condensed',
        'expanded',
        'extra-condensed',
        'extra-expanded',
        'normal',
        'semi-condensed',
        'semi-expanded',
        'ultra-condensed',
        'ultra-expanded',
      ],
    },
    'font-style': { values: ['italic', 'normal', 'oblique'] },
    'font-synthesis': { values: ['none', 'style', 'weight'] },
    'font-variant': { values: ['normal', 'small-caps'] },
    'font-variant-alternates': { values: ['normal'] },
    'font-variant-caps': {
      values: [
        'normal',
        'small-caps',
        'all-small-caps',
        'petite-caps',
        'all-petite-caps',
        'unicase',
        'titling-caps',
      ],
    },
    'font-variant-east-asian': { values: ['normal'] },
    'font-variant-ligatures': { values: ['normal', 'none'] },
    'font-variant-numeric': { values: ['normal'] },
    'font-variant-position': { values: ['normal', 'sub', 'super'] },
    'font-weight': {
      values: [
        'bold',
        'bolder',
        'lighter',
        'normal',
        '100',
        '200',
        '300',
        '400',
        '500',
        '600',
        '700',
        '800',
        '900',
      ],
    },
    gap: { values: ['revert-layer'] },
    grid: { values: [] },
    'grid-area': { values: [] },
    'grid-auto-columns': { values: [] },
    'grid-auto-flow': { values: ['row', 'column', 'dense'] },
    'grid-auto-rows': { values: [] },
    'grid-column': { values: ['auto'] },
    'grid-column-end': { values: [] },
    'grid-column-gap': { values: [] },
    'grid-column-start': { values: [] },
    'grid-gap': { values: [] },
    'grid-row': { values: ['auto'] },
    'grid-row-end': { values: [] },
    'grid-row-start': { values: [] },
    'grid-row-gap': { values: [] },
    'grid-template': { values: ['none'] },
    'grid-template-areas': { values: [] },
    'grid-template-columns': { values: ['auto'] },
    'grid-template-rows': { values: ['auto'] },
    'hanging-punctuation': {
      values: ['allow-end', 'first', 'force-end', 'last', 'none'],
    },
    height: { values: ['auto', 'max-content', 'min-content', 'fit-content'] },
    hyphens: { values: ['auto', 'manual', 'none'] },
    'image-orientation': { values: [] },
    'image-resolution': { values: ['from-image', 'snap'] },
    isolation: { values: ['auto', 'isolate'] },
    'justify-content': {
      values: [
        'center',
        'flex-end',
        'flex-start',
        'space-around',
        'space-between',
      ],
    },
    'justify-items': {
      values: [
        'auto',
        'normal',
        'stretch',
        'center',
        'start',
        'end',
        'flex-start',
        'flex-end',
        'self-start',
        'self-end',
        'left',
        'right',
        'baseline',
        'first',
        'last',
        'safe',
        'unsafe',
        'legacy',
      ],
    },
    'justify-self': {
      values: [
        'auto',
        'normal',
        'stretch',
        'center',
        'start',
        'end',
        'flex-start',
        'flex-end',
        'self-start',
        'self-end',
        'left',
        'right',
        'baseline',
        'first',
        'last',
        'safe',
        'unsafe',
      ],
    },
    left: { values: ['auto'] },
    'letter-spacing': { values: ['normal'] },
    'line-height': { values: ['normal'] },
    'list-style': {
      values: [
        'none',
        'url()',
        'armenian',
        'circle',
        'decimal',
        'decimal-leading-zero',
        'disc',
        'georgian',
        'inside',
        'lower-alpha',
        'lower-greek',
        'lower-latin',
        'lower-roman',
        'outside',
        'square',
        'upper-alpha',
        'upper-latin',
        'upper-roman',
      ],
    },
    'list-style-image': { values: ['none', 'url()'] },
    'list-style-position': { values: ['inside', 'outside'] },
    'list-style-type': {
      values: [
        'armenian',
        'circle',
        'decimal',
        'decimal-leading-zero',
        'disc',
        'georgian',
        'lower-alpha',
        'lower-greek',
        'lower-latin',
        'lower-roman',
        'none',
        'square',
        'upper-alpha',
        'upper-latin',
        'upper-roman',
      ],
    },
    margin: { values: ['auto'] },
    'margin-bottom': { values: ['auto'] },
    'margin-left': { values: ['auto'] },
    'margin-right': { values: ['auto'] },
    'margin-top': { values: ['auto'] },
    'max-height': { values: ['none'] },
    'max-width': { values: ['none'] },
    'min-height': { values: [] },
    'min-width': { values: [] },
    'mix-blend-mode': {
      values: [
        'color',
        'color-burn',
        'color-dodge',
        'darken',
        'difference',
        'exclusion',
        'hard-light',
        'hue',
        'lighten',
        'luminosity',
        'multiply',
        'normal',
        'overlay',
        'saturation',
        'screen',
        'soft-light',
      ],
    },
    'object-fit': {
      values: ['contain', 'cover', 'fill', 'none', 'scale-down'],
    },
    'object-position': { values: ['left', 'center', 'right', 'bottom', 'top'] },
    opacity: { values: [] },
    order: { values: [] },
    orphans: { values: [] },
    outline: { values: [] },
    'outline-color': { values: ['invert'], type: 'color' },
    'outline-offset': { values: [] },
    'outline-style': {
      values: [
        'dashed',
        'dotted',
        'double',
        'groove',
        'hidden',
        'inset',
        'none',
        'outset',
        'ridge',
        'solid',
      ],
    },
    'outline-width': { values: ['medium', 'thin', 'thick'] },
    overflow: { values: ['auto', 'hidden', 'scroll', 'visible'] },
    'overflow-x': { values: ['auto', 'hidden', 'scroll', 'visible'] },
    'overflow-y': { values: ['auto', 'hidden', 'scroll', 'visible'] },
    'overflow-wrap': { values: ['normal', 'anywhere', 'break-word'] },
    padding: { values: [] },
    'padding-bottom': { values: [] },
    'padding-left': { values: [] },
    'padding-right': { values: [] },
    'padding-top': { values: [] },
    'page-break-after': {
      values: ['always', 'auto', 'avoid', 'left', 'right'],
    },
    'page-break-before': {
      values: ['always', 'auto', 'avoid', 'left', 'right'],
    },
    'page-break-inside': { values: ['auto', 'avoid'] },
    perspective: { values: ['none'] },
    'perspective-origin': {
      values: ['bottom', 'center', 'left', 'right', 'top'],
    },
    'pointer-events': {
      values: [
        'all',
        'auto',
        'fill',
        'none',
        'painted',
        'stroke',
        'visible',
        'visibleFill',
        'visiblePainted',
        'visibleStroke',
      ],
    },
    position: { values: ['absolute', 'fixed', 'relative', 'static', 'sticky'] },
    quotes: { values: ['none'] },
    'region-break-after': {
      values: [
        'always',
        'auto',
        'avoid',
        'avoid-column',
        'avoid-page',
        'avoid-region',
        'column',
        'left',
        'page',
        'region',
        'right',
      ],
    },
    'region-break-before': {
      values: [
        'always',
        'auto',
        'avoid',
        'avoid-column',
        'avoid-page',
        'avoid-region',
        'column',
        'left',
        'page',
        'region',
        'right',
      ],
    },
    'region-break-inside': {
      values: ['auto', 'avoid', 'avoid-column', 'avoid-page', 'avoid-region'],
    },
    'region-fragment': { values: ['auto', 'break'] },
    resize: { values: ['both', 'horizontal', 'none', 'vertical'] },
    right: { values: ['auto'] },
    'scroll-behavior': { values: ['auto', 'smooth'] },
    'scroll-snap-type': {
      values: [
        'none',
        'x',
        'y',
        'block',
        'inline',
        'both',
        'mandatory',
        'proximity',
      ],
    },
    src: { values: ['url()'] },
    'shape-image-threshold': { values: [] },
    'shape-inside': {
      values: [
        'auto',
        'circle()',
        'ellipse()',
        'outside-shape',
        'polygon()',
        'rectangle()',
      ],
    },
    'shape-margin': { values: [] },
    'shape-outside': {
      values: [
        'none',
        'circle()',
        'ellipse()',
        'polygon()',
        'inset()',
        'margin-box',
        'border-box',
        'padding-box',
        'content-box',
        'url()',
        'image()',
        'linear-gradient()',
        'radial-gradient()',
        'repeating-linear-gradient()',
        'repeating-radial-gradient()',
      ],
    },
    'tab-size': { values: [] },
    'table-layout': { values: ['auto', 'fixed'] },
    'text-align': {
      values: [
        'start',
        'end',
        'center',
        'left',
        'justify',
        'right',
        'match-parent',
        'justify-all',
      ],
    },
    'text-align-last': { values: ['center', 'left', 'justify', 'right'] },
    'text-decoration': {
      values: ['line-through', 'none', 'overline', 'underline'],
    },
    'text-decoration-color': { values: [], type: 'color' },
    'text-decoration-line': {
      values: ['line-through', 'none', 'overline', 'underline'],
    },
    'text-decoration-skip': {
      values: ['edges', 'ink', 'none', 'objects', 'spaces'],
    },
    'text-decoration-style': {
      values: ['dashed', 'dotted', 'double', 'solid', 'wavy'],
    },
    'text-emphasis': { values: [] },
    'text-emphasis-color': { values: [], type: 'color' },
    'text-emphasis-position': { values: ['above', 'below', 'left', 'right'] },
    'text-emphasis-style': {
      values: [
        'circle',
        'dot',
        'double-circle',
        'filled',
        'none',
        'open',
        'sesame',
        'triangle',
      ],
    },
    'text-indent': { values: [] },
    'text-justify': {
      values: ['auto', 'none', 'inter-word', 'inter-character'],
    },
    'text-overflow': { values: ['clip', 'ellipsis'] },
    'text-shadow': { values: [] },
    'text-rendering': {
      values: [
        'auto',
        'geometricPrecision',
        'optimizeLegibility',
        'optimizeSpeed',
      ],
    },
    'text-transform': {
      values: ['capitalize', 'full-width', 'lowercase', 'none', 'uppercase'],
    },
    'text-underline-position': {
      values: ['alphabetic', 'auto', 'below', 'left', 'right'],
    },
    top: { values: ['auto'] },
    transform: {
      values: [
        'matrix()',
        'matrix3d()',
        'none',
        'perspective()',
        'rotate()',
        'rotate3d()',
        'rotateX()',
        'rotateY()',
        'rotateZ()',
        'scale()',
        'scale3d()',
        'scaleX()',
        'scaleY()',
        'scaleZ()',
        'skewX()',
        'skewY()',
        'translate()',
        'translate3d()',
        'translateX()',
        'translateY()',
        'translateZ()',
      ],
    },
    'transform-origin': {
      values: ['bottom', 'center', 'left', 'right', 'top'],
    },
    'transform-style': { values: ['flat', 'preserve-3d'] },
    transition: { values: [] },
    'transition-delay': { values: [] },
    'transition-duration': { values: [] },
    'transition-property': { values: ['all', 'none'] },
    'transition-timing-function': {
      values: [
        'cubic-bezier()',
        'ease',
        'ease-in',
        'ease-in-out',
        'ease-out',
        'linear',
        'step-end',
        'step-start',
        'steps()',
      ],
    },
    'unicode-bidi': { values: ['bidi-override', 'embed', 'normal'] },
    'unicode-range': { values: [] },
    'user-select': { values: ['all', 'auto', 'contain', 'none', 'text'] },
    'vertical-align': {
      values: [
        'baseline',
        'bottom',
        'middle',
        'sub',
        'super',
        'text-bottom',
        'text-top',
        'top',
      ],
    },
    visibility: { values: ['collapse', 'hidden', 'visible'] },
    'white-space': {
      values: ['normal', 'nowrap', 'pre', 'pre-line', 'pre-wrap'],
    },
    widows: { values: [] },
    width: { values: ['auto', 'max-content', 'min-content', 'fit-content'] },
    'will-change': {
      values: ['auto', 'contents', 'opacity', 'scroll-position'],
    },
    'word-break': { values: ['normal', 'break-all', 'keep-all'] },
    'word-spacing': { values: ['normal'] },
    'z-index': { values: ['auto'] },
  },
};

export const CSSProperties = CSSSourceInfo.cssKeyValue;

export const CSSColors = CSSSourceInfo.cssColors;

export type CSSPropertiesKey = keyof typeof CSSProperties;

export const CSSPropertyList = Object.keys(CSSSourceInfo.cssKeyValue);
